import React from 'react';
export function IntroContent() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1169">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1170">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border mb-12" style={{
        borderColor: '#ede9e0'
      }} data-id="element-1171">
          <p className="text-base text-gray-800 leading-relaxed italic" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1172">
            Students can satisfy MI CPL renewal requirements by auditing our
            standard CPL (NRA Personal Protection in Home) class. A stand alone
            renewal class may be offered if demand is high.
          </p>
        </div>
      </div>
    </div>;
}